/**
 * Resolves a row's height given whether it should auto-size to its (wrapped)
 * content. Returns `undefined` for auto-height rows so AG Grid grows the row
 * to fit wrapped text instead of clipping it at `fixedHeight`.
 */
export const getAutoHeightRowHeight = (
  isAutoHeightRow: boolean,
  fixedHeight: number,
): number | undefined => (isAutoHeightRow ? undefined : fixedHeight);
